import React from 'react';
import {
  Container,
  Heading,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Text,
  Box,
} from '@chakra-ui/react';
import {
  SECTION_TITLE_CONTAINER_BG,
  SECTION_TITLE_TEXT_COLOR,
} from './constants';

const buildFaqGroups = (prezzoSettimana, prezzoFratelli, prezzoMVP) => ({
  Pagamenti: [
    {
      q: 'Posso pagare in due tranche?',
      a: "Sì. Puoi scegliere tra acconto (per confermare) e saldo (entro il venerdì prima della settimana) oppure pagamento totale in un'unica soluzione.",
    },
    {
      q: 'Come funziona lo sconto fratelli?',
      a: `Quando un altro fratello/socio dello stesso account è già iscritto alla stessa settimana, il secondo (e successivi) paga ${prezzoFratelli}€ invece di ${prezzoSettimana}€. Lo sconto si applica automaticamente in fase di prenotazione.`,
    },
    {
      q: "Come funziona l'MVP?",
      a: `Se selezioni tutte le settimane con opzione "totale", il prezzo del pacchetto è ${prezzoMVP}€ (prezzo fisso). Non si applica se scegli acconto/saldo su una o più settimane.`,
    },
  ],
});

const FAQSection = ({ event, hideTitle }) => {
  const prezzoSettimana =
    event?.Varianti?.[0]?.prezzoVariante ?? event?.prezzo ?? 120;
  const scontoFratelli = event?.Sconto_Fratelli ?? 20;
  const prezzoFratelli = prezzoSettimana - (Number(scontoFratelli) || 0);
  const prezzoMVP =
    event?.Sconto_MVP != null && event?.Sconto_MVP !== ''
      ? Number(event.Sconto_MVP)
      : 700;
  const groups = buildFaqGroups(prezzoSettimana, prezzoFratelli, prezzoMVP);

  const content = (
    <Box maxW="700px">
      {Object.entries(groups).map(([groupTitle, items]) => (
        <Box key={groupTitle} mb={6}>
          <Accordion allowToggle>
            {items.map((item) => (
              <AccordionItem key={item.q} mb={2}>
                <AccordionButton py={3}>
                  <Text
                    flex="1"
                    textAlign="left"
                    fontWeight="bold"
                    fontSize="sm"
                  >
                    {item.q}
                  </Text>
                  <AccordionIcon />
                </AccordionButton>
                <AccordionPanel pb={4} fontSize="sm">
                  {item.a}
                </AccordionPanel>
              </AccordionItem>
            ))}
          </Accordion>
        </Box>
      ))}
    </Box>
  );

  if (hideTitle) {
    return (
      <Container maxW="container.lg" px={{ base: 4, md: 6 }}>
        {content}
      </Container>
    );
  }

  return (
    <Box as="section" py={8}>
      <Container maxW="container.lg" px={{ base: 4, md: 6 }}>
        <Heading as="h2" size="lg" mb={6}>
          <Box
            display="inline-block"
            px={4}
            py={3}
            borderRadius="lg"
            sx={{ background: SECTION_TITLE_CONTAINER_BG }}
            boxShadow="sm"
          >
            <Text as="span" fontWeight="bold" color={SECTION_TITLE_TEXT_COLOR}>
              Domande frequenti
            </Text>
          </Box>
        </Heading>
        {content}
      </Container>
    </Box>
  );
};

export default FAQSection;
